import type {SearchCriteriaRaw} from '../../../types';
import {createCartRule} from '../cartRule';
import type {CartRule, TSearchTypeCart} from '../types';

export type RawCartSearchCriteria = SearchCriteriaRaw<TSearchTypeCart>;

export const rawCartCriteriaToRuleObject = (
	criteria: RawCartSearchCriteria,
): CartRule => {
	return createCartRule(parseInt(criteria.value1) || 0);
};

export default rawCartCriteriaToRuleObject;
